import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../../../../../Components/CSS/TableStyle.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import CustomTableHead from "../../../../../Components/Table/CustomTableHeader/CustomTableHeader";
import CustomTableFooter from "../../../../../Components/Table/CutomTableFooter/CustomTableFooter";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import ExamFilter from "../ExamFilter/ExamFilter";
import CustomSiteLoader from "../../../../../Components/CustomSiteLoader/CustomSiteLoader";
import CustomEmptyMessage from "../../../../../Components/CustomEmptyMessage/CustomEmptyMessage";
import Axios from "axios";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import AddExam from "../AddExam/AddExam";
import ExamBody from "../ExamBody/ExamBody";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class ViewExam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rowsPerPage: 10,
      page: 0,
      search: {
        name: "",
      },
      isEmpty: false,
      detailStatus: false,
      detailData: [],
      column: [{ name: "S.N." }, { name: "Exam Name" }, { name: "Actions" }],
      exams: [],
    };
  }

  componentDidMount() {
    this.getExams();
  }

  getExams = async () => {
    try {
      const response = await Axios.get(`${url}/api/exam-types`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.examTypes.length !== 0) {
        this.setState({
          exams: response.data.examTypes,
          isEmpty: false,
        });
      } else {
        this.setState({
          exams: [],
          isEmpty: true,
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getExams();
      }
    }
  };

  handleDetailStatus = (detailData) => {
    this.setState({
      detailStatus: true,
      detailData,
    });
  };

  handleCancelDetail = () => {
    this.setState({
      detailStatus: false,
    });
  };

  handleSearch = (e) => {
    this.setState({
      search: {
        ...this.state.search,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePage = (e, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleRowsPerPage = (e) => {
    this.setState({
      rowsPerPage: +e.target.value,
      page: 0,
    });
  };

  render() {
    const { classes } = this.props;
    const { rowsPerPage, page } = this.state;
    const filtered = this.state.exams.filter((subject) => {
      return (
        subject.name
          .toLowerCase()
          .indexOf(this.state.search.name.toLowerCase()) !== -1
      );
    });
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          <PageTitle title="Exam Types" refreshUrl={this.props.match.url} />
          <Grid container spacing={3}>
            <Grid item xs={12} sm={12} md={4} xl={4} lg={4}>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                Add New Exam Type
              </div>
              <AddExam getExams={this.getExams} />
            </Grid>
            <Grid item xs={12} sm={12} md={8} xl={8} lg={8}>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>Exam List</div>
              {this.state.exams.length !== 0 && (
                <ExamFilter
                  data={this.state.search}
                  handleSearch={this.handleSearch}
                />
              )}
              {this.state.exams.length !== 0 ? (
                <Paper>
                  <TableContainer>
                    <Table>
                      <CustomTableHead column={this.state.column} />

                      <TableBody>
                        {(rowsPerPage > 0
                          ? filtered.slice(
                              rowsPerPage * page,
                              rowsPerPage * page + rowsPerPage
                            )
                          : filtered
                        ).map((exams, index) => (
                          <ExamBody
                            data={exams}
                            key={index}
                            index={index}
                            handleDetailStatus={this.handleDetailStatus}
                            getExams={this.getExams}
                          />
                        ))}
                      </TableBody>

                      <CustomTableFooter
                        count={filtered.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onChangePage={this.handlePage}
                        onChangeRowsPerPage={this.handleRowsPerPage}
                      />
                    </Table>
                  </TableContainer>
                </Paper>
              ) : this.state.isEmpty ? (
                <CustomEmptyMessage />
              ) : (
                <CustomSiteLoader />
              )}
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(ViewExam)));
